import {
  UtilizationDashboardEmbedUrlErrorCode,
  useGetUtilizationDashboardEmbedUrlQuery,
} from '../../graphQL';

const GENERIC_ERROR_MESSAGE = 'There was an error, please try again later.';

type UseGetUtilizationEmbedUrlResult =
  | { status: 'loading' }
  | {
      status: 'error';
      errorMessage: string;
      errorCode: UtilizationDashboardEmbedUrlErrorCode | null;
    }
  | { status: 'success'; embedUrl: string };

export const useGetUtilizationEmbedUrl = (): UseGetUtilizationEmbedUrlResult => {
  const { data, loading, error } = useGetUtilizationDashboardEmbedUrlQuery();

  if (loading) {
    return { status: 'loading' };
  }

  if (error) {
    return { status: 'error', errorMessage: error.message, errorCode: null };
  }

  const result = data?.getUtilizationDashboardEmbedUrl;

  if (!result || result.__typename !== 'UtilizationDashboardEmbedUrl') {
    const errorResult = result?.__typename === 'UtilizationDashboardEmbedUrlError' ? result : null;

    return {
      status: 'error',
      errorMessage: errorResult?.message ?? GENERIC_ERROR_MESSAGE,
      errorCode: errorResult?.errorCode ?? null,
    };
  }

  return { status: 'success', embedUrl: result.url };
};
